module.exports = __webpack_public_path__ + "img/img-multisucursal.3391a8b7.webp";